import React, { useState, useEffect } from "react";
import { Modal, Select, Input, Button, Row, Col, Spin, message } from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import FiltersDynamic from "../Components/FiltersDynamicComponent"; // Import the FiltersDynamic component
const { Option } = Select;

const ExportModal = ({ fieldsData,isExportModalVisible, setIsExportModalVisible, objectPluralName, objectName, record }) => {
  const [loading, setLoading] = useState(false);
  // Use 'filters' state to be compatible with FiltersDynamic, initialize as an empty array
  const [filters, setFilters] = useState([]);
  const [logic, setLogic] = useState("AND");
  // FiltersDynamic expects 'valueOperator' for each filter, initialize it here
  const [valueOperator, setValueOperator] = useState({});

  useEffect(() => {
    if (isExportModalVisible) {
      // Reset filters to default when modal is opened
      setFilters([]);
      setLogic("AND"); // Reset logic as well if needed
      setValueOperator({}); // Reset valueOperator
    }
  }, [isExportModalVisible]);

  const handleExportClick = async () => {
    setLoading(true);
    console.log('filters in export:: ',filters);
    const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
          acc[index + 1] = {
              field: filter.field,
              value: filter.operator && (filter.value === undefined || filter.value === "")
                  ? { [filter.operator]: "" }  // If operator exists and value is empty or undefined, set as JSON object
                  : (filter.value === undefined ? "" : filter.value)  // If value is undefined, set it to an empty string
          };
      }
      return acc;
    }, {});
    console.log('filterObj', filterObj);
    

    // Transform filters from FiltersDynamic format to the backend's expected format
    const transformedFilters = filters.reduce((acc, filter) => {
      if (filter.field && filter.value) {
        acc[filter.field] = filter.value;
      }
      return acc;
    }, {});
    let filterLogic = '';
    const filterObjKeys = Object.keys(filterObj);
    if (filterObjKeys.length === 1) {
        filterLogic = '1';
    } else if (filterObjKeys.length > 1) {
        filterLogic = logic || '';
    }

    console.log('filterLogic', filterLogic);
    

    const body = { object_name: objectName, conditions: filterObj,logic_string:filterLogic };
    console.log('body for export::',body);

    try {
      const apiServiceForExport = new ApiService(
        `${BASE_URL}/export_to_csv`,
        { "Content-Type": "application/json" },
        "POST",
        body
      );
      const response = await apiServiceForExport.makeCall();

      if (!response || response.trim() === "") {
        throw new Error("Empty response from server");
      }

      const lines = response.trim().split("\n");
      if (lines.length <= 1) {
        throw new Error("No data rows found in the response");
      }

      const blob = new Blob([response], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${objectName}_Export.csv`);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      message.success("CSV file has been exported successfully");
      setIsExportModalVisible(false);
    } catch (error) {
      console.error("Error exporting records:", error);
      message.error(error.message || "Error exporting CSV file");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsExportModalVisible(false);
    setFilters([]); // Reset filters on cancel
    setValueOperator({}); // Reset valueOperator on cancel
  };

  // Prepare fields for FiltersDynamic based on the 'record' prop
  const fields = record ? Object.keys(record).map(key => ({ label: key, value: key })) : [];

  return (
    <Modal
      title={`Export ${objectPluralName} Records`}
      visible={isExportModalVisible}
      onOk={handleExportClick}
      onCancel={handleCancel}
      zIndex={1002}   // higher than sidebar
      okText="Export"
      cancelText="Cancel"
      centered
      width={700} // Adjust width as needed for FiltersDynamic
    >
      <Spin spinning={loading} tip="Loading..." size="small">
        {/* <p>Define Filter Parameters:</p> */}
        <FiltersDynamic
          fields={fieldsData}
          logic={logic}
          setLogic={setLogic}
          filters={filters}
          setFilters={setFilters}
          setValueOperator={setValueOperator}
          valueOperator={valueOperator}
          // You might not need these for export, but include if FiltersDynamic expects them
          fetchLookupRecordsForExistingFilters={() => {}}
          fetchLookupRecords={() => {}}
          lookupOptions={{}}
          heading={false} // Assuming you don't need a heading inside the modal
        />
      </Spin>
    </Modal>
  );
};

export default ExportModal;